// wasteDisposalForm/basicInfo/actions.js

export const makeWasteDisposalFormBasicInfoActions = ({
  setWasteDisposalUi,
  bump,
  emitWdPatch,
}) => ({
  updateWdClientName(wdData, clientName, emitPatch) {
    wdData.basicInfo.updateTextAttribute("clientName", clientName);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ clientName });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdDisposalDate(wdData, disposalDate, emitPatch) {
    wdData.basicInfo.updateDisposalDate(disposalDate);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({
        disposalDate: wdData.basicInfo.disposalDate,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdGeneratorName(wdData, generatorName, emitPatch) {
    wdData.basicInfo.updateTextAttribute("generatorName", generatorName);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ generatorName });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdContact(wdData, contact, emitPatch) {
    wdData.basicInfo.updateTextAttribute("contact", contact);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ contact });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdPhoneNumber(wdData, phoneNumber, emitPatch) {
    wdData.basicInfo.updateTextAttribute("phoneNumber", phoneNumber);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ phoneNumber });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdFaxNumber(wdData, faxNumber, emitPatch) {
    wdData.basicInfo.updateTextAttribute("faxNumber", faxNumber);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ faxNumber });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdStreetAddress(wdData, streetAddress, emitPatch) {
    wdData.basicInfo.updateTextAttribute("streetAddress", streetAddress);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ streetAddress });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdCity(wdData, city, emitPatch) {
    wdData.basicInfo.updateTextAttribute("city", city);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ city });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdState(wdData, state, emitPatch) {
    const stateValue = state || "";
    wdData.basicInfo.updateTextAttribute("state", stateValue);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ state: stateValue });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdZipcode(wdData, zipcode, emitPatch) {
    wdData.basicInfo.updateTextAttribute("zipcode", zipcode);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ zipcode });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },
});
